<template>
  <div>
    <apexchart
      v-if="sortedEntries.length"
      type="bar"
      :height="Math.max(300, sortedEntries.length * 44 + 80)"
      :options="opts"
      :series="series"
    />
    <div
      v-else
      class="d-flex justify-center align-center grey--text text--lighten-1"
      style="min-height: 400px"
    >
      <span class="text-body-2">{{ $t("no_data") }}</span>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const SHIFT_COLORS = ["#1E88E5", "#43A047", "#FB8C00", "#8E24AA"];

export default {
  name: "MoreRestaurantsCompaniesChart",
  components: { apexchart: VueApexCharts },
  props: {
    orders: { type: Array, default: () => [] },
  },
  computed: {
    shiftLabels() {
      return [
        this.$t("1st_shift"),
        this.$t("2nd_shift"),
        this.$t("3rd_shift"),
        this.$t("4th_shift"),
      ];
    },
    sortedEntries() {
      return this.orders
        .map((c) => ({
          name: this.toLatin(c.name),
          shifts: [
            c.totals.shift_one || 0,
            c.totals.shift_two || 0,
            c.totals.shift_three || 0,
            c.totals.shift_four || 0,
          ],
          total: c.totals.total || 0,
        }))
        .filter((e) => e.total > 0)
        .sort((a, b) => b.total - a.total);
    },
    categories() {
      return this.sortedEntries.map((e) => e.name);
    },
    series() {
      return this.shiftLabels.map((label, i) => ({
        name: label,
        data: this.sortedEntries.map((e) => e.shifts[i]),
      }));
    },
    opts() {
      return {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          fontFamily: "Roboto, sans-serif",
        },
        plotOptions: { bar: { horizontal: true, borderRadius: 3, barHeight: "65%" } },
        colors: SHIFT_COLORS,
        xaxis: { categories: this.categories, labels: { style: { fontSize: "12px" } } },
        yaxis: { labels: { style: { fontSize: "12px" }, maxWidth: 220 } },
        legend: { position: "bottom", horizontalAlign: "center" },
        dataLabels: { enabled: false },
        tooltip: { shared: true, intersect: false },
        fill: { opacity: 1 },
        grid: { borderColor: "#f1f1f1" },
      };
    },
  },
};
</script>
